// extracted by mini-css-extract-plugin
module.exports = {"label":"AddressSelect_label__1reWe","select":"AddressSelect_select__GJVCa","error":"AddressSelect_error__2s8fa"};